const NAME_PATTERN = /^[a-zA-Z\u00C0-\u024F][a-zA-Z\u00C0-\u024F\s'.-]*$/;
const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const normalizeDigits = (value) => String(value || '').replace(/\D/g, '');

export const validateCustomerFirstName = (value) => {
  const name = String(value || '').trim();
  if (!name) {
    return 'Please enter your first name.';
  }
  if (name.length < 2) {
    return 'First name must be at least 2 characters.';
  }
  if (name.length > 50) {
    return 'First name is too long.';
  }
  if (!NAME_PATTERN.test(name)) {
    return 'First name can only contain letters, spaces, hyphens, and apostrophes.';
  }
  return '';
};

export const validateCustomerLastName = (value) => {
  const name = String(value || '').trim();
  if (!name) {
    return '';
  }
  if (name.length < 2) {
    return 'Family name must be at least 2 characters.';
  }
  if (name.length > 50) {
    return 'Family name is too long.';
  }
  if (!NAME_PATTERN.test(name)) {
    return 'Family name can only contain letters, spaces, hyphens, and apostrophes.';
  }
  return '';
};

export const validateCustomerEmail = (value) => {
  const email = String(value || '').trim();
  if (!email) {
    return 'Please enter your email address.';
  }
  if (email.length > 254) {
    return 'Email address is too long.';
  }
  if (!EMAIL_PATTERN.test(email)) {
    return 'Please enter a valid email address.';
  }
  return '';
};

export const validateCustomerPhone = (value) => {
  const raw = String(value || '').trim();
  if (!raw) {
    return 'Please enter your mobile number.';
  }
  const digits = normalizeDigits(raw);
  if (digits.length < 10 || digits.length > 15) {
    return 'Please enter a valid mobile number (10–15 digits).';
  }
  if (raw.startsWith('+') && !/^\+[0-9\s().-]+$/.test(raw)) {
    return 'Mobile number format is not valid.';
  }
  return '';
};

/**
 * @param {{ firstName?: string, lastName?: string, phone?: string, email?: string }} fields
 */
export const validateCheckoutCustomerDetails = (fields) => {
  const errors = {
    firstName: validateCustomerFirstName(fields.firstName),
    lastName: validateCustomerLastName(fields.lastName),
    phone: validateCustomerPhone(fields.phone),
    email: validateCustomerEmail(fields.email),
  };

  return {
    valid: !errors.firstName && !errors.lastName && !errors.phone && !errors.email,
    errors,
  };
};
